import { createSlice, current } from '@reduxjs/toolkit';
import {
	getReportingFrequencyList,
	getReportingFrequency,
	addNewReportingFrequency,
	updateReportingFrequency,
	deleteReportingFrequency,
	checkReportingFrequencyExists,
} from './thunk';

export const initialState = {
	itemReportingFrequencyList: [],
	itemReportingFrequency: null,
	isReportingFrequencyLoading: false,
	isReportingFrequencySuccess: false,
	dataReportingFrequency: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const ReportingFrequencySlice = createSlice({
	name: 'ReportingFrequency',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getReportingFrequencyList.pending, state => {
			state.isLoadingList = true;
			state.isReportingFrequencySuccess = false;
		});

		builder.addCase(getReportingFrequencyList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemReportingFrequencyList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isReportingFrequencySuccess = true;
		});

		builder.addCase(getReportingFrequencyList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isReportingFrequencySuccess = false;
		});

		builder.addCase(getReportingFrequency.pending, state => {
			state.isReportingFrequencyLoading = true;
			state.isReportingFrequencySuccess = false;
		});

		builder.addCase(getReportingFrequency.fulfilled, (state, action) => {
			state.itemReportingFrequency = action.payload;
			state.isReportingFrequencyLoading = false;
			state.isReportingFrequencySuccess = true;
		});

		builder.addCase(getReportingFrequency.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isReportingFrequencyLoading = false;
			state.isReportingFrequencySuccess = false;
		});

		builder.addCase(addNewReportingFrequency.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewReportingFrequency.fulfilled, (state, action) => {
			state.itemReportingFrequencyList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewReportingFrequency.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateReportingFrequency.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateReportingFrequency.fulfilled, (state, action) => {
			state.itemReportingFrequencyList = state.itemReportingFrequencyList.map(
				item =>
					item._id.toString() === action.payload._id.toString()
						? { ...item, ...action.payload }
						: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateReportingFrequency.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteReportingFrequency.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteReportingFrequency.fulfilled, (state, action) => {
			state.itemReportingFrequencyList = current(
				state.itemReportingFrequencyList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteReportingFrequency.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkReportingFrequencyExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkReportingFrequencyExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkReportingFrequencyExists.rejected, state => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = ReportingFrequencySlice.actions;

export default ReportingFrequencySlice.reducer;
